module.exports = __webpack_public_path__ + "static/media/img7.5d3cd39d.png";